import { isAxiosError, type AxiosError } from 'axios';

/**
 * ดึงข้อความ error สำหรับแสดงผู้ใช้ — รองรับ Axios, Error, และ object จาก API
 */
export function getErrorMessage(error: unknown, fallback = 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'): string {
  if (error == null) return fallback;
  if (typeof error === 'string') return error;

  if (isAxiosError(error)) {
    const ax = error as AxiosError<{ message?: string }>;
    const msg = ax.response?.data?.message;
    if (typeof msg === 'string' && msg.length > 0) return msg;
    if (typeof ax.message === 'string' && ax.message.length > 0) return ax.message;
    return fallback;
  }

  if (error instanceof Error && error.message) return error.message;

  return fallback;
}
